import React from "react";
import { defineMessages } from "react-intl";
import "@mui/material";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import { renderValueWithTooltip } from "../../../components/data-grid/mui/cells/GridCellWithTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import { GlobalServerErrorMessage } from "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
const localizedHeaders = defineMessages({
  bulkResultsGridRowIndex: {
    id: "bulkResultsGridRowIndex",
    defaultMessage: "Row Index"
  },
  bulkResultsGridError: {
    id: "bulkResultsGridError",
    defaultMessage: "Error"
  }
});
class DataGridBulkResultsConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      rowIndex: {
        field: "rowIndex",
        valueGetter: (_, row) => this.getRowIndex(row),
        renderHeader: () => renderCellHeader(localizedHeaders.bulkResultsGridRowIndex),
        flex: 0.15,
        sortable: false
      },
      error: {
        field: "error",
        renderCell: (p) => renderValueWithTooltip(/* @__PURE__ */ React.createElement(LocalizedText, { label: this.getError(p) })),
        renderHeader: () => renderCellHeader(localizedHeaders.bulkResultsGridError),
        flex: 0.45,
        sortable: false
      },
      errorRawLocalized: {
        field: "errorRawLocalized",
        renderCell: (p) => renderValueWithTooltip(/* @__PURE__ */ React.createElement(GlobalServerErrorMessage, { error: this.getErrorRaw(p), hasError: this.hasError(p) })),
        renderHeader: () => renderCellHeader(localizedHeaders.bulkResultsGridError),
        flex: 0.45,
        sortable: false
      },
      rawErrorMessage: {
        field: "rawErrorMessage",
        renderCell: (p) => renderValueWithTooltip(this.getErrorRaw(p)),
        renderHeader: () => renderCellHeader(localizedHeaders.bulkResultsGridError),
        flex: 0.45,
        sortable: false
      }
    };
    return columnsMapping;
  }
  getRowIndex(model) {
    return model?.rowIndex;
  }
  getError(p) {
    return this.getRow(p)?.error;
  }
  getErrorRaw(p) {
    return this.getRow(p)?.rawErrorMessage;
  }
  hasError(p) {
    return this.getRow(p)?.rawErrorMessage !== void 0;
  }
}
export {
  DataGridBulkResultsConfigFactory
};
//# sourceMappingURL=DataGrid.js.map
